export default {
  title: '船代管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '船代名称、EDI代码',
    port: '港口',
    portPlaceholder: '选择港口',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addShipAgent: '新增船代',
    selectFromLibrary: '新增船代',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    edit: '编辑',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    agentName: '代理名称',
    ediCode: 'EDI代码',
    port: '港口',
    abbreviation: '英文简称',
    status: '状态',
    operation: '操作'
  },

  // 表单
  form: {
    addTitle: '新增船代',
    editTitle: '编辑船代',
    agentCode: '船代代码',
    agentCodePlaceholder: '请输入船代代码',
    agentNameCn: '船代名称（中文）',
    agentNameCnPlaceholder: '请输入中文名称',
    agentNameEn: '船代名称（英文）',
    agentNameEnPlaceholder: '请输入英文名称',
    country: '国家',
    countryPlaceholder: '选择国家',
    city: '城市',
    cityPlaceholder: '请输入城市',
    contactPerson: '联系人',
    contactPersonPlaceholder: '请输入联系人',
    phone: '联系电话',
    phonePlaceholder: '请输入联系电话',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱地址',
    status: '状态',
    statusPlaceholder: '选择状态'
  },

  // 选择弹窗
  modal: {
    title: '新增船代',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个船代，共 {total} 个可选'
  },

  // 确认对话框
  confirm: {
    enableItem: '确定要启用此船代吗？',
    disableItem: '确定要禁用此船代吗？',
    batchEnable: '确定要启用选中的 {count} 个船代吗？',
    batchDisable: '确定要禁用选中的 {count} 个船代吗？'
  },

  // 表单验证
  validation: {
    agentCodeRequired: '请输入船代代码',
    agentNameCnRequired: '请输入中文名称',
    agentNameEnRequired: '请输入英文名称',
    countryRequired: '请选择国家',
    contactPersonRequired: '请输入联系人',
    phoneRequired: '请输入联系电话',
    emailRequired: '请输入邮箱地址',
    emailFormat: '请输入正确的邮箱格式',
    selectItems: '请选择要关联的船代'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的船代',
    selectToDisable: '请选择要禁用的船代',
    selectToAssociate: '请选择要关联的船代',
    loadError: '船代数据加载失败，请稍后重试',
    platformLoadError: '平台船代数据加载失败，请稍后重试',
    saveSuccess: '船代保存成功',
    saveError: '保存失败，请稍后重试',
    updateSuccess: '船代更新成功',
    updateError: '更新失败，请稍后重试',
    associateSuccess: '成功关联 {count} 个船代',
    associateError: '关联失败，请稍后重试',
    statusToggleSuccess: '船代已{status}',
    statusToggleError: '状态切换失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个船代',
    batchEnableError: '批量启用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个船代',
    batchDisableError: '批量禁用失败，请稍后重试'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  }
}